import { useEffect, useState } from "react";
import { Dropdown, Button, ButtonGroup } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import { ERASER, BUSQUEDA, DROPUP } from "../iconsSVG/IconsSVG";
import "./DropDownBuble.css";
import { getBuscarAnotaciones } from "../../services/buscarTomos";

const DropDownBuble = ({ tomo, onRecargarResultados, onLimpiarFiltros }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 50); // Cambia "50" por el valor que prefieras
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const realizarBusqueda = async () => {
    setLoading(true);
    try {
      const resultados = await getBuscarAnotaciones(tomo);
      onRecargarResultados(tomo, resultados);
    } catch (error) {
      console.error("Error al realizar la búsqueda:", error, loading);
    } finally {
      setLoading(false);
    }
  };

  const limpiarResultadosYFiltros = () => {
    // onRecargarResultados(tomo, []);
    onLimpiarFiltros(tomo);
  };

  return (
    // <div className="dropdown-container">
    //   <DropdownButton className="desplegable-transparente"
    //     as={ButtonGroup}
    //     key={"up"}
    //     id={`dropdown-button-drop-down`}
    //     drop={"up"}
    //     variant="none"
    //     style={{ backgroundColor: "white" }}
    //     >
    //    <Dropdown.Item as="button"><Button className="dropdown-button"
    //         onClick={limpiarResultadosYFiltros}
    //       > <ERASER />&nbsp;&nbsp;LIMPIAR
    //       </Button></Dropdown.Item>
    //   <Dropdown.Item as="button">
    //   <Button  className="dropdown-button"
    //         onClick={realizarBusqueda}
    //       > <BUSQUEDA />&nbsp;&nbsp;BUSCAR </Button></Dropdown.Item>
    //   </DropdownButton>
    // </div>
    <div>
      {showButton && (
        <Button  className="fixed-dropup" title= "Subir al principio de la página" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <DROPUP/>
        </Button>
        /* <Button className="fixed-limpiar" title= "LIMPIAR" onClick={limpiarResultadosYFiltros}> 
          <ERASER />
        </Button> 
        <Button  className="fixed-buscar" title= "BUSCAR" onClick={realizarBusqueda}>
          <BUSQUEDA />
        </Button> */
      )}
    </div>
  );
};

export default DropDownBuble;
